// =============================================================================
// usePoliciesDue — how many policies this user still has to read and sign.
// =============================================================================
// James, 29 Sep 2026, showing the guys in the field: "the crew can't find the
// policies". They existed (My policies → open → acknowledge) but nothing on the
// phone said so. This one number feeds the nudge on the field home and the
// badge in the phone menu, so both say the same thing and refetch together.
//
// Same view and the same rule as MyPoliciesScreen: v_policy_pending_for_user,
// anything whose ack_status is not 'current' needs the person's attention
// (never signed, annual re-ack due, major revision pending).
// =============================================================================
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export function usePoliciesDue(userId: string | null | undefined): number {
  const { data } = useQuery({
    queryKey: ["my_policies_due", userId],
    enabled: !!userId,
    staleTime: 60_000,
    queryFn: async () => {
      const { count, error } = await supabase
        .from("v_policy_pending_for_user")
        .select("policy_id", { count: "exact", head: true })
        .eq("user_id", userId!)
        .neq("ack_status", "current");
      if (error) throw error;
      return count ?? 0;
    },
  });
  return data ?? 0;
}
